{
  "de": {
    "upload": {
      "labels": {
        "cancelUpload": "Upload abbrechen",
        "cancelUploadConfirmation": "Sind Sie sicher, dass Sie diesen Upload abbrechen möchten?",
        "chooseCategory": "Klicken, um zuerst eine Kategorie auszuwählen",
        "defaultMessage": "Dateien hinzufügen oder hier ablegen",
        "fallbackMessage": "Ihr Browser unterstützt keine Datei-Uploads per Drag & Drop.",
        "fallbackText": "Verwenden Sie das folgende Formular, um Ihre Dateien auf herkömmliche Weise hochzuladen.",
        "fileTooBig": "Datei ist zu groß ({filesize} MB). Maximale Dateigröße: {maxFilesize} MB.",
        "invalidFileType": "Sie können Dateien dieses Typs nicht hochladen.",
        "maxFilesExceeded": "Sie können keine weiteren Dateien hochladen.",
        "noExtension": "Datei hat keine Dateiendung",
        "rejectedFiles": "Die folgenden Dateien wurden abgelehnt:",
        "removeFile": "Datei entfernen",
        "responseError": "Server antwortete mit Code {statusCode}.",
        "uploadConfirmation": "Upload bestätigt",
        "uploadError": "Upload-Fehler",
        "warningMaxFileSize": "Bis zu {max_files_size} pro Datei"
      }
    }
  }
}
